module.exports = __webpack_public_path__ + "img/animated-traffic-light.512f362e.gif";